var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isGrid || _vm.isList
    ? _c("div", { staticClass: "properties-listing" }, [
        _c("div", { staticClass: "default-content" }, [
          _vm.properties && _vm.properties.length
            ? _c(
                "div",
                {
                  staticClass: "properties-listing__area",
                  class: { "list-view": _vm.isList }
                },
                _vm._l(_vm.properties, function(property) {
                  return _c("div", { staticClass: "properties-item" }, [
                    _c(
                      "div",
                      { staticClass: "properties-item__image-holder" },
                      [
                        property.listingMainPhoto
                          ? _c("img", {
                              staticClass: "properties-item__image",
                              attrs: { src: property.listingMainPhoto }
                            })
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "properties-item__info" }, [
                      _c(
                        "div",
                        { staticClass: "properties-item__heading" },
                        [
                          _c("div", { staticClass: "properties-item__title" }, [
                            _c(
                              "div",
                              { staticClass: "properties-item__address" },
                              [
                                _vm._v(
                                  _vm._s(property.postcode) +
                                    ", " +
                                    _vm._s(
                                      property.location &&
                                        property.location.name
                                    )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "properties-item__name" },
                              [_vm._v(_vm._s(property.listingAddressIn))]
                            )
                          ]),
                          _vm._v(" "),
                          this.location.href.indexOf("staffhousing") == -1 &&
                          property.show_price == 1
                            ? [
                                _vm.booking == 1
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "properties-item__price"
                                        },
                                        [
                                          property.booking_period == 1
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "properties-item__price-value"
                                                },
                                                [
                                                  _vm._v(
                                                    "€ " +
                                                      _vm._s(
                                                        property.ah_day_price &&
                                                          property.ah_day_price.indexOf(
                                                            ",00"
                                                          ) == -1
                                                          ? property.ah_day_price.indexOf(
                                                              ","
                                                            ) != -1
                                                            ? property.ah_day_price
                                                            : property.ah_day_price +
                                                              ",-"
                                                          : property.ah_day_price
                                                          ? property.ah_day_price.replace(
                                                              ",00",
                                                              ",-"
                                                            )
                                                          : ""
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        property.ah_price_includes_short
                                                      )
                                                  )
                                                ]
                                              )
                                            : property.booking_period == 2
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "properties-item__price-value"
                                                },
                                                [
                                                  _vm._v(
                                                    "€ " +
                                                      _vm._s(
                                                        property.ah_week_price &&
                                                          property.ah_week_price.indexOf(
                                                            ",00"
                                                          ) == -1
                                                          ? property.ah_week_price.indexOf(
                                                              ","
                                                            ) != -1
                                                            ? property.ah_week_price
                                                            : property.ah_week_price +
                                                              ",-"
                                                          : property.ah_week_price
                                                          ? property.ah_week_price.replace(
                                                              ",00",
                                                              ",-"
                                                            )
                                                          : ""
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        property.ah_price_includes_short
                                                      )
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "properties-item__price-value"
                                                },
                                                [
                                                  _vm._v(
                                                    "€ " +
                                                      _vm._s(
                                                        property.ah_price &&
                                                          property.ah_price.indexOf(
                                                            ",00"
                                                          ) == -1
                                                          ? property.ah_price.indexOf(
                                                              ","
                                                            ) != -1
                                                            ? property.ah_price
                                                            : property.ah_price +
                                                              ",-"
                                                          : property.ah_price
                                                          ? property.ah_price.replace(
                                                              ",00",
                                                              ",-"
                                                            )
                                                          : ""
                                                      ) +
                                                      " " +
                                                      _vm._s(
                                                        property.ah_price_includes_short
                                                      )
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          property.booking_period == 1
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "properties-item__price-note"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.locales.property &&
                                                        _vm.locales.property
                                                          .a_day
                                                    )
                                                  )
                                                ]
                                              )
                                            : property.booking_period == 2
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "properties-item__price-note"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.locales.property &&
                                                        _vm.locales.property
                                                          .a_week
                                                    )
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "properties-item__price-note"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.locales.properties &&
                                                        _vm.locales.properties
                                                          .a_month
                                                    )
                                                  )
                                                ]
                                              )
                                        ]
                                      )
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "properties-item__price"
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "properties-item__price-value"
                                            },
                                            [
                                              _vm._v(
                                                "€ " +
                                                  _vm._s(
                                                    property.ah_price &&
                                                      property.ah_price.indexOf(
                                                        ",00"
                                                      ) == -1
                                                      ? property.ah_price.indexOf(
                                                          ","
                                                        ) != -1
                                                        ? property.ah_price
                                                        : property.ah_price +
                                                          ",-"
                                                      : property.ah_price
                                                      ? property.ah_price.replace(
                                                          ",00",
                                                          ",-"
                                                        )
                                                      : ""
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    property.ah_price_includes_short
                                                  )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "properties-item__price-note"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.locales.properties &&
                                                    _vm.locales.properties
                                                      .a_month
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                              ]
                            : this.location.href.indexOf("staffhousing") == -1
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "properties-item__price" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "properties-item__price-value"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.locales.properties &&
                                              _vm.locales.properties
                                                .price_on_request
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            : [
                                _c(
                                  "div",
                                  { staticClass: "properties-item__price" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "properties-item__price-value"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.locales.properties &&
                                              _vm.locales.properties
                                                .max_number_of_persons
                                          ) +
                                            " " +
                                            _vm._s(property.max_people)
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "properties-item__bottom" }, [
                        _c(
                          "div",
                          { staticClass: "properties-item__parameters" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "properties-item__parameters-item"
                              },
                              [
                                _c("i", { staticClass: "icon-ruler" }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(property.area) +
                                    " m²\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "properties-item__parameters-item"
                              },
                              [
                                _c("i", { staticClass: "icon-bed" }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(property.no_bedrooms) +
                                    "\n              "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "properties-item__parameters-item"
                              },
                              [
                                _c("i", { staticClass: "icon-furniture" }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      property.furnishing_object
                                        ? property.furnishing_object.value
                                        : "-"
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "theme-btn theme-btn--small theme-btn--theme",
                            attrs: { href: property.url }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.locales.common &&
                                    _vm.locales.common.view_more
                                ) +
                                "\n              "
                            ),
                            _c("i", { staticClass: "icon-go-right" })
                          ]
                        )
                      ])
                    ])
                  ])
                }),
                0
              )
            : _c("div", { staticClass: "properties-listing__empty" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "properties-listing__empty-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.locales.properties &&
                        _vm.locales.properties.no_properties
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "properties-listing__empty-text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.locales.properties &&
                        _vm.locales.properties.try_reset_filters
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "theme-btn theme-btn--tertiary",
                    on: { click: _vm.resetFilters }
                  },
                  [
                    _c("i", {
                      staticClass: "icon-replay",
                      staticStyle: { "font-size": "20px" }
                    }),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.locales.properties &&
                            _vm.locales.properties.reset_filters
                        ) +
                        "\n      "
                    )
                  ]
                )
              ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "properties-listing__empty-icon-holder" }, [
      _c("i", { staticClass: "icon-home properties-listing__empty-icon" })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fd29276", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fd29276","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/PropertiesListing.vue
// module id = 677
// module chunks = 1